<script>
	import { onMount } from "svelte";
	
	let decor;
	let scrolledBefore = 0;
	let transform = () => {};
	
	function animateDecor() {
		// right Page of "Now" container. So actual displayed page:
		const rightContainer = document.querySelector('.container > .right');
		const scrolled = rightContainer ? rightContainer.scrollTop : 0;
		if(scrolledBefore !== scrolled) {
			transform = (factor) => {
				return `translateY(${Math.max(-200, scrolled * factor)}px)`;
			}
		}
		scrolledBefore = scrolled;
		requestAnimationFrame(animateDecor);
	}
	function decorInNowPage(element) {
		if(!element.parentElement) {
			return false;
		}
		return element.parentElement.classList.contains('now') || decorInNowPage(element.parentElement);
	}
	
	onMount(() => {
		if(decorInNowPage(decor)) {
			animateDecor();
		}
	})
</script>

<div class="decor" bind:this={decor}>
	<img class="back" style="transform: {transform(-.5)}" loading="lazy" alt="AES HUB - Phone 1"
		 src="./../img/20.AES_HUB/01.decor/Phone_1_Mockup.webp">
	<img class="front" style="transform: {transform(-1)}" loading="lazy" alt="AES HUB - Phone 2"
		 src="./../img/20.AES_HUB/01.decor/Phone_2_Mockup.webp">
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 12.5vw;
		top: -3.5vw;
		height: auto;
		margin: 0;
		padding: 0;
		position: absolute;

		&.back {
			right: 7.5vw;
			aspect-ratio: 259 / 410;
		}
		&.front {
			top: -7vw;
			right: 0;
			aspect-ratio: 242 / 408;
		}
	}
	
	.decor {
		width: 45%;
		position: absolute;
		height: 12vmax;
		top: -15px;
		right: 0;
		z-index: -1;

		@include for-tablet-portrait-up {
			width: 25%;
		}
		
		@include for-tablet-landscape-up {
			width: 20%;
		}
	}

</style>
